import React from 'react';

import { flagStyles } from '../settings';

const SvgNP = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3984px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNP;
